








import { defineComponent, PropType } from '@vue/composition-api';
import { Mod } from '@c/landingpage/modpack/types';
import { useAsset } from '@a/plugins/assets';

export default defineComponent({
  name: 'BaseModpackImage',
  props: {
    value: {
      type: Object as PropType<Mod>,
      required: true,
    },
  },
  setup: () => {
    const { modpackIcon } = useAsset();

    const onError = (event: ErrorEvent) => {
      const image = (event.currentTarget as HTMLImageElement);

      image.onerror = null;
      image.src = modpackIcon('placeholder.webp');
    };

    return {
      onError,
      modpackIcon,
    };
  },
});
